/**
 * Where a deal's proposal is built (docs/proposal-v2/S10.md §3.1, AC1) —
 * pure, so the rule is tested once and every launcher agrees.
 *
 * A deal already on the new builder (`proposalBuilderVersion === 2`) ALWAYS
 * opens there: the old builder would drop its V2 fields on save. Any other
 * deal opens there when the launcher rule allows it (`v2Allowed` — the
 * tenant's `featureFlags.proposalBuilderV2`, or an admin; read through
 * `useProposalBuilderV2Allowed`), else in the old builder exactly as before.
 *
 * Exception: a V1 deal whose proposal was already SENT from the old builder
 * (`nativeProposalId` set, `proposalBuilderVersion` not 2) stays in the old
 * builder even when the rule allows V2 — the new builder's Send header would
 * otherwise offer "Update customer's copy" against a V1 snapshot and silently
 * convert the customer's live document to the V2 layout.
 */

import type { Deal } from '@/types/theo-workflow.types';

type LaunchDeal = Pick<Deal, 'id' | 'proposalBuilderVersion' | 'nativeProposalId'>;

/** Does this deal's proposal open in the new builder? */
export function opensInV2(deal: LaunchDeal, v2Allowed: boolean): boolean {
  if (deal.proposalBuilderVersion === 2) return true;
  return v2Allowed && !deal.nativeProposalId;
}

/** The builder URL for a deal: `/home/deals/<id>/proposal-v2` or the old `/home/deals/<id>/proposal`. */
export function proposalBuilderPath(deal: LaunchDeal, v2Allowed: boolean): string {
  return `/home/deals/${deal.id}/${opensInV2(deal, v2Allowed) ? 'proposal-v2' : 'proposal'}`;
}
